$(function() {
  
    menu_resize();

	$('.js-toggle-languages-menu').on('click', function(){

        $('body').toggleClass('open-languages-menu');
        $('html,body').removeClass('open-menu');
        $('.main-menu > li').removeClass('active');
        $('.js-menu-image').removeClass('opacity-0');
        $('.js-set-mobile-content-here').empty();
    });


    $('.js-toggle-menu').on('click', function(){
		
        $('html,body').toggleClass('open-menu');
        $('body').removeClass('open-languages-menu');
        $('.main-menu > li').removeClass('active');

        if(!$('body').hasClass('open-menu')) { 
            $('.js-menu-image').removeClass('opacity-0'); 
            $('.js-set-mobile-content-here').empty();
        }

	});

    $('.main-menu > li > a').on('click', function(){
		
        $('.main-menu > li').removeClass('active');
        $(this).parent().toggleClass('active');
        $('.js-menu-image').addClass('opacity-0');

        if($(document).width() < 1024){ set_moblie_menu_content($(this).parent()); }

        return false;

	});


});

function set_moblie_menu_content(_li){

    var _content = _li.find('.inner-content .mobile').addClass('hidden').clone().removeClass('hidden');
        _content.addClass('opacity-0 transition-opacity duration-100 pointer-events-auto');

    $('.js-set-mobile-content-here').html(_content);
    _content.removeClass('opacity-0');
    

}


$(window).on('resize', function(){

	menu_resize();

});

function menu_resize(){

    _w = $('.main-menu').width();
    _w += 20;
    $('.main-menu').find('.menu-item-content').css('left', _w + 'px'); 

    _W = $('.js-menu-container').innerWidth() - 35;
    $('.main-menu').find('.menu-item-content').css('width', (_W - _w) + 'px');

}
